(function () {
  'use strict';

  var API_BASE = 'https://api.judge.me/api/v1';
  var STAR_PATH = 'M8 0L9.88914 5.81283H16L11.056 9.40604L12.9452 15.2177L8 11.6245L3.05603 15.2177L4.94397 9.40484L0 5.81163H6.11086L8 0Z';

  var VERIFIED_SVG =
    '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<circle cx="8" cy="8" r="8" fill="currentColor"/>' +
      '<path d="M4.6 8.15l2.1 2.1 4.7-4.7" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  var ARROW_LEFT =
    '<svg viewBox="0 0 21 20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">' +
      '<path stroke-linecap="round" stroke-linejoin="round" d="M18 10H3M3 10l5.8 5.8M3 10l5.8-5.8"/>' +
    '</svg>';

  var ARROW_RIGHT =
    '<svg viewBox="0 0 21 20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">' +
      '<path stroke-linecap="round" stroke-linejoin="round" d="M3 10h15M18 10l-5.8-5.8M18 10l-5.8 5.8"/>' +
    '</svg>';

  function getRoots(scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll('[data-judgeme-reviews]'));
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function shuffle(items) {
    var list = items.slice();
    for (var i = list.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = list[i];
      list[i] = list[j];
      list[j] = tmp;
    }
    return list;
  }

  function parseIntSafe(text) {
    if (!text) return 0;
    var match = String(text).match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  }

  function parseFloatSafe(text) {
    if (!text) return 0;
    var match = String(text).match(/[\d.]+/);
    return match ? parseFloat(match[0]) : 0;
  }

  function wakeJudgeMeWidgets() {
    if (typeof window.jdgm_preloader === 'function') {
      window.jdgm_preloader();
    }
    document.dispatchEvent(new CustomEvent('jdgm.widget.load'));
  }

  function getApiConfig(root) {
    return {
      apiToken: (root.getAttribute('data-api-token') || '').trim(),
      shopDomain: (root.getAttribute('data-shop-domain') || (window.jdgm && window.jdgm.SHOP_DOMAIN) || '').trim()
    };
  }

  function hasApiConfig(root) {
    var config = getApiConfig(root);
    return !!(config.apiToken && config.shopDomain);
  }

  function buildApiUrl(endpoint, config, params) {
    var query = [
      'shop_domain=' + encodeURIComponent(config.shopDomain),
      'platform=shopify',
      'api_token=' + encodeURIComponent(config.apiToken)
    ];

    Object.keys(params || {}).forEach(function (key) {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        query.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
      }
    });

    return API_BASE + '/' + endpoint + '?' + query.join('&');
  }

  function fetchWidget(root, endpoint, params) {
    var config = getApiConfig(root);
    if (!config.apiToken || !config.shopDomain) {
      return Promise.reject(new Error('Missing Judge.me API config'));
    }

    return fetch(buildApiUrl('widgets/' + endpoint, config, params), {
      method: 'GET',
      credentials: 'omit',
      cache: 'no-store'
    }).then(function (response) {
      return response.text().then(function (body) {
        if (!response.ok) {
          throw new Error('Judge.me API error: ' + response.status);
        }
        return JSON.parse(body);
      });
    });
  }

  function parseWidgetHtml(html) {
    var wrap = document.createElement('div');
    wrap.innerHTML = html || '';
    return wrap;
  }

  function cleanReviewBody(text) {
    return String(text || '')
      .replace(/\d{1,2}\/\d{1,2}\/\d{2,4}\s*\|\s*ICED\s*STUFF/gi, '')
      .replace(/\|\s*ICED\s*STUFF/gi, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function anonymizeName(name) {
    var raw = String(name || '').trim();
    if (!raw) return 'Klient';

    return raw.split(/\s+/).map(function (part) {
      if (part.length <= 2) return part[0] + '*';
      if (part.length <= 4) return part[0] + '**' + part.slice(-1);
      return part[0] + '**' + part.slice(-1);
    }).join(' ');
  }

  function getReviewRatingFromNode(reviewNode) {
    var score = parseFloat(reviewNode.getAttribute('data-score'));

    if (!score) {
      var scoreEl = reviewNode.querySelector('[data-score]');
      if (scoreEl) score = parseFloat(scoreEl.getAttribute('data-score'));
    }

    if (!score) {
      var ratingEl = reviewNode.querySelector('.jdgm-rev__rating');
      if (ratingEl) score = parseFloat(ratingEl.getAttribute('data-score'));
    }

    if (!score) {
      score = reviewNode.querySelectorAll('.jdgm-star.jdgm--on').length;
    }

    if (!score || score < 1) return 5;
    return Math.min(5, Math.max(1, Math.round(score)));
  }

  function extractPhotosFromNode(node) {
    var photos = [];
    var seen = {};

    Array.prototype.slice.call(node.querySelectorAll('.jdgm-rev__pic img, .jdgm-rev__pics img, img[data-src], a.jdgm-gallery__link')).forEach(function (el) {
      var src = '';
      if (el.tagName === 'A') {
        src = el.getAttribute('href') || el.getAttribute('data-huge-url') || '';
      } else {
        src = el.getAttribute('src') || el.getAttribute('data-src') || el.getAttribute('data-original-image-url') || '';
      }
      if (!src || src.indexOf('data:') === 0 || seen[src]) return;
      seen[src] = true;
      photos.push(src);
    });

    return photos;
  }

  function parseReviewFromNode(node) {
    var authorEl = node.querySelector('.jdgm-rev__author, .jdgm-rev__buyer-name, .jdgm-carousel-item__reviewer-name');
    var bodyEl = node.querySelector('.jdgm-rev__body, .jdgm-carousel-item__review-body, .jdgm-rev__content, .jdgm-line-clamp');
    var timeEl = node.querySelector('.jdgm-rev__timestamp, time, .jdgm-rev__created-at');
    var body = cleanReviewBody(bodyEl ? bodyEl.textContent.trim() : '');

    if (!body) {
      body = cleanReviewBody(node.textContent.trim());
      if (authorEl) body = body.replace(authorEl.textContent.trim(), '').trim();
    }

    if (!body || body.length < 5) return null;

    var author = authorEl ? authorEl.textContent.trim() : '';
    if (!author) {
      var iconEl = node.querySelector('.jdgm-rev__icon');
      if (iconEl) author = iconEl.textContent.trim();
    }

    var dateText = '';
    if (timeEl) {
      dateText = (timeEl.getAttribute('datetime') || timeEl.getAttribute('data-content') || timeEl.textContent || '').trim();
    }

    var country = '';
    var countryEl = node.querySelector('[data-country], .jdgm-rev__country, .jdgm-rev__location');
    if (countryEl) {
      country = (countryEl.getAttribute('data-country') || countryEl.textContent || '').trim();
    }

    var verified = !!(
      node.querySelector('.jdgm-rev__buyer-badge, .jdgm-rev__verified, .jdgm-rev__icon--verified') ||
      node.classList.contains('jdgm-rev--verified') ||
      node.getAttribute('data-verified-buyer') === 'true'
    );

    return {
      id: node.getAttribute('data-review-id') || '',
      rating: getReviewRatingFromNode(node) || 5,
      author: author,
      body: body,
      date: formatDate(dateText),
      country: country,
      verified: verified || true,
      photos: extractPhotosFromNode(node)
    };
  }

  function formatDate(raw) {
    if (!raw) return '';
    var cleaned = String(raw).replace(/\s+/g, ' ').trim();

    // 2026-10-15: Safari (iPhone) nie parsuje „2025-08-21 11:22:58 UTC” — pokazywał surowy zapis z godziną.
    // Format judge.me rozbieramy sami; inne zapisy dalej przez Date.parse
    var m = cleaned.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/);
    var parsed = m
      ? Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), +(m[6] || 0))
      : Date.parse(cleaned);
    if (!isNaN(parsed)) {
      try {
        return new Intl.DateTimeFormat('pl-PL', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        }).format(new Date(parsed));
      } catch (e) {
        return cleaned;
      }
    }

    return cleaned;
  }

  function getReviewNodesFromHtml(html) {
    var wrap = parseWidgetHtml(html);
    var nodes = wrap.querySelectorAll('.jdgm-rev[data-review-id]');
    if (!nodes.length) nodes = wrap.querySelectorAll('[data-review-id].jdgm-rev');
    if (!nodes.length) nodes = wrap.querySelectorAll('.jdgm-rev');
    return Array.prototype.slice.call(nodes);
  }

  function parseReviewsFromWidgetHtml(html) {
    var reviews = [];
    getReviewNodesFromHtml(html).forEach(function (node) {
      var review = parseReviewFromNode(node);
      if (review) reviews.push(review);
    });
    return reviews;
  }

  function uniqueReviews(reviews) {
    var seen = {};
    var unique = [];
    reviews.forEach(function (review) {
      var key = review.id || (review.author + '|' + review.body.slice(0, 80));
      if (!key || seen[key]) return;
      seen[key] = true;
      unique.push(review);
    });
    return unique;
  }

  function getAllReviewsPageHtml(data) {
    if (!data) return '';
    if (data.all_reviews) return data.all_reviews;
    if (data.widget) return data.widget;
    if (data.all_reviews_header) return data.all_reviews_header;
    return '';
  }

  function getWidgetField(data, endpoint) {
    if (!data) return '';
    if (data.widget != null) return data.widget;
    var map = {
      all_reviews_page: 'all_reviews',
      all_reviews_rating: 'all_reviews_rating',
      all_reviews_count: 'all_reviews_count',
      product_review: 'product_review'
    };
    var key = map[endpoint];
    if (key && data[key] != null) return data[key];
    return '';
  }

  function parseSummaryFromWidgetHtml(html) {
    var wrap = parseWidgetHtml(html);
    var averageEl = wrap.querySelector('.jdgm-rev-widg__summary-average, [data-average-rating]');
    var summaryText = wrap.querySelector('.jdgm-rev-widg__summary-text, [data-number-of-reviews]');
    var average = 0;
    var total = 0;

    if (averageEl) {
      average = parseFloatSafe(averageEl.getAttribute('data-average-rating') || averageEl.textContent);
    }
    if (summaryText) {
      total = parseIntSafe(summaryText.getAttribute('data-number-of-reviews') || summaryText.textContent);
    }

    if (!average && !total) return null;
    return { average: average, total: total };
  }

  function buildStarsHtml(rating, size) {
    var starSize = size || 14;
    var rounded = Math.min(5, Math.max(0, Math.round(rating || 0)));
    var html = '';

    for (var i = 1; i <= 5; i++) {
      var filled = i <= rounded;
      html +=
        '<svg class="reviews-list__star' + (filled ? '' : ' reviews-list__star--off') + '" width="' + starSize + '" height="' + starSize + '" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<path d="' + STAR_PATH + '"/>' +
        '</svg>';
    }

    return html;
  }

  function collectGalleryPhotos(reviews) {
    var photos = [];
    var seen = {};
    reviews.forEach(function (review) {
      (review.photos || []).forEach(function (src) {
        if (!src || seen[src]) return;
        seen[src] = true;
        photos.push(src);
      });
    });
    return photos.slice(0, 12);
  }

  function updateSummary(root, summary) {
    if (!summary || !(summary.average > 0 || summary.total > 0)) return;

    var ratingEl = root.querySelector('.reviews-list__rating');
    var starsEl = root.querySelector('[data-judgeme-summary-stars]');
    var avgEl = root.querySelector('[data-judgeme-summary-average]');

    if (ratingEl) {
      ratingEl.hidden = false;
      ratingEl.setAttribute('aria-label', (summary.average || 0).toFixed(1) + ' na 5');
    }
    if (starsEl) starsEl.innerHTML = buildStarsHtml(summary.average || 5, 14);
    if (avgEl) avgEl.textContent = (summary.average || 0).toFixed(1);
  }

  function renderPhotos(root, photos) {
    var wrap = root.querySelector('[data-judgeme-photos]');
    var track = root.querySelector('[data-judgeme-photos-track]');
    if (!wrap || !track) return;

    if (!photos.length) {
      wrap.hidden = true;
      track.innerHTML = '';
      return;
    }

    track.innerHTML = photos.map(function (src) {
      return (
        '<a class="reviews-list__photo" href="' + src + '" target="_blank" rel="noopener">' +
          '<img src="' + src + '" alt="" loading="lazy">' +
        '</a>'
      );
    }).join('');
    wrap.hidden = false;
  }

  function renderReviewItem(review) {
    var photosHtml = '';
    if (review.photos && review.photos.length) {
      photosHtml =
        '<div class="reviews-list__item-photos">' +
          review.photos.slice(0, 3).map(function (src) {
            return '<img src="' + src + '" alt="" loading="lazy">';
          }).join('') +
        '</div>';
    }

    var metaParts = [];
    if (review.country && review.country.length <= 3) {
      metaParts.push('<span class="reviews-list__country">' + escapeHtml(review.country) + '</span>');
    }

    return (
      '<article class="reviews-list__item">' +
        '<div class="reviews-list__consumer">' +
          '<div class="reviews-list__author-row">' +
            '<p class="reviews-list__author">' + escapeHtml(anonymizeName(review.author)) + '</p>' +
            (review.verified ? '<span class="reviews-list__verified" title="Zweryfikowany zakup">' + VERIFIED_SVG + '</span>' : '') +
          '</div>' +
          (metaParts.length ? '<div class="reviews-list__meta">' + metaParts.join('') + '</div>' : '') +
        '</div>' +
        '<div class="reviews-list__content">' +
          '<div class="reviews-list__item-stars" aria-label="Ocena ' + review.rating + ' na 5">' + buildStarsHtml(review.rating, 12) + '</div>' +
          '<p class="reviews-list__body-text">' + escapeHtml(review.body) + '</p>' +
          photosHtml +
        '</div>' +
      '</article>'
    );
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderPage(root, state, page) {
    var listEl = root.querySelector('[data-judgeme-list]');
    var loadingEl = root.querySelector('[data-judgeme-loading]');
    var paginationEl = root.querySelector('[data-judgeme-pagination]');
    var pagesEl = root.querySelector('[data-judgeme-pages]');
    var perPage = state.perPage;
    var totalPages = Math.max(1, Math.ceil(state.reviews.length / perPage));
    var current = Math.min(Math.max(page || 1, 1), totalPages);
    var start = (current - 1) * perPage;
    var slice = state.reviews.slice(start, start + perPage);

    state.page = current;

    if (listEl) {
      listEl.innerHTML = slice.map(renderReviewItem).join('');
      listEl.hidden = false;
    }
    if (loadingEl) loadingEl.hidden = true;

    if (!paginationEl || !pagesEl) return;

    if (totalPages <= 1) {
      paginationEl.hidden = true;
      pagesEl.innerHTML = '';
      return;
    }

    var html = '';
    html += '<li><button type="button" class="reviews-list__page-btn" data-page-prev aria-label="Poprzednia strona"' + (current === 1 ? ' disabled' : '') + '>' + ARROW_LEFT + '</button></li>';

    var maxButtons = 5;
    var startPage = Math.max(1, current - Math.floor(maxButtons / 2));
    var endPage = Math.min(totalPages, startPage + maxButtons - 1);
    startPage = Math.max(1, endPage - maxButtons + 1);

    for (var p = startPage; p <= endPage; p++) {
      html +=
        '<li><button type="button" class="reviews-list__page' + (p === current ? ' is-current' : '') + '" data-page="' + p + '" aria-label="Strona ' + p + '"' + (p === current ? ' aria-current="page"' : '') + '>' + p + '</button></li>';
    }

    html += '<li><button type="button" class="reviews-list__page-btn" data-page-next aria-label="Następna strona"' + (current === totalPages ? ' disabled' : '') + '>' + ARROW_RIGHT + '</button></li>';

    pagesEl.innerHTML = html;
    paginationEl.hidden = false;
  }

  function bindPagination(root, state) {
    if (root.getAttribute('data-judgeme-pagination-bound') === 'true') return;
    root.setAttribute('data-judgeme-pagination-bound', 'true');

    root.addEventListener('click', function (event) {
      var target = event.target.closest('[data-page], [data-page-prev], [data-page-next]');
      if (!target || !root.contains(target)) return;

      event.preventDefault();

      if (target.hasAttribute('data-page-prev')) {
        renderPage(root, state, state.page - 1);
        return;
      }
      if (target.hasAttribute('data-page-next')) {
        renderPage(root, state, state.page + 1);
        return;
      }

      var page = parseInt(target.getAttribute('data-page'), 10);
      if (page) renderPage(root, state, page);
    });
  }

  function setupWriteReview(root) {
    var writeWidget = root.querySelector('[data-judgeme-write-widget] .jdgm-review-widget');
    if (!writeWidget) return;

    wakeJudgeMeWidgets();

    Array.prototype.slice.call(root.querySelectorAll('style.jdgm-temp-hiding-style')).forEach(function (el) {
      el.remove();
    });

    var tries = 0;
    function polish() {
      tries += 1;
      var link = writeWidget.querySelector('.jdgm-write-rev-link, .jdgm-btn, .jdgm-widget-actions-wrapper a');
      if (link) {
        link.classList.add('button', 'button--primary');
        return;
      }
      if (tries < 12) setTimeout(polish, 400);
    }
    polish();
  }

  function calculateSummaryFromReviews(reviews) {
    var total = reviews.length;
    if (!total) return { average: 0, total: 0 };
    var sum = 0;
    reviews.forEach(function (r) { sum += r.rating || 0; });
    return { average: sum / total, total: total };
  }

  function finishWithReviews(root, reviews, summary, shopSummary) {
    var state = {
      reviews: uniqueReviews(reviews),
      perPage: Math.max(parseInt(root.getAttribute('data-per-page'), 10) || 5, 1),
      page: 1
    };

    var finalSummary = summary && summary.average
      ? summary
      : calculateSummaryFromReviews(state.reviews);

    if (summary && summary.total && !finalSummary.total) {
      finalSummary.total = summary.total;
    }

    // Prefer metafield totals when available
    var metaCount = shopSummary ? 0 : parseInt(root.getAttribute('data-review-count'), 10) || 0;
    var metaAvg = shopSummary ? 0 : parseFloat(root.getAttribute('data-rating-average')) || 0;
    if (metaCount > 0) finalSummary.total = metaCount;
    if (metaAvg > 0) finalSummary.average = metaAvg;

    updateSummary(root, finalSummary);
    renderPhotos(root, collectGalleryPhotos(state.reviews));
    bindPagination(root, state);
    renderPage(root, state, 1);
    setupWriteReview(root);

    if (!state.reviews.length) {
      var loadingEl = root.querySelector('[data-judgeme-loading]');
      if (loadingEl) {
        loadingEl.hidden = false;
        loadingEl.textContent = 'Brak opinii do wyświetlenia.';
      }
    }
  }

  function parseProductSource(root) {
    var source = root.querySelector('[data-judgeme-product-source]');
    if (!source) return { reviews: [], summary: null, html: '' };

    var html = source.innerHTML;
    var reviews = parseReviewsFromWidgetHtml(html);
    var summary = parseSummaryFromWidgetHtml(html);
    return { reviews: reviews, summary: summary, html: html };
  }

  function fetchShopReviews(root) {
    // 2026-10-15 (Karol: „jedna strona opinii, tylko zawsze niech się losują inne”): tyle opinii, ile mieści jedna
    // strona listy (per_page sekcji, domyślnie 5), więc bez paginacji; display_count z sekcji nie podnosi limitu
    var displayCount = Math.max(parseInt(root.getAttribute('data-per-page'), 10) || 5, 1);
    var loadingEl = root.querySelector('[data-judgeme-loading]');

    if (!hasApiConfig(root)) {
      if (loadingEl) {
        loadingEl.textContent = 'Brak Public API Token — ustaw go w sekcji Judge.me opinie.';
      }
      return Promise.resolve();
    }

    // 2026-10-15 (Karol: „zawsze losowe opinie odnośnie sklepu”): tylko opinie o sklepie, losowane z dwóch losowych
    // stron po 25 (judge.me oddaje maks. 25 na stronę; 360 opinii = 15 stron), a nie z samych najnowszych
    var SHOP_PAGES = 14;
    var pages = shuffle(Array.apply(null, Array(SHOP_PAGES)).map(function (_, i) { return i + 1; })).slice(0, 2);

    return Promise.all([
      fetchWidget(root, 'all_reviews_rating', {}),
      fetchWidget(root, 'all_reviews_count', {})
    ].concat(pages.map(function (page) {
      return fetchWidget(root, 'all_reviews_page', { page: page, per_page: 25, review_type: 'shop-reviews' }).catch(function () {
        return null;
      });
    }))).then(function (results) {
      var average = parseFloatSafe(getWidgetField(results[0], 'all_reviews_rating'));
      var total = parseIntSafe(getWidgetField(results[1], 'all_reviews_count'));
      var reviews = [];
      results.slice(2).forEach(function (data) {
        if (data) reviews = reviews.concat(parseReviewsFromWidgetHtml(getAllReviewsPageHtml(data)));
      });
      var picked = shuffle(uniqueReviews(reviews)).slice(0, displayCount);

      return {
        reviews: picked,
        summary: {
          average: average || calculateSummaryFromReviews(picked).average,
          total: total || picked.length
        }
      };
    }).then(function (result) {
      // Podsumowanie sklepu, nie metapola produktu (inaczej przy produkcie z opiniami liczba nie pasowałaby do listy)
      finishWithReviews(root, result.reviews, result.summary, true);
    }).catch(function () {
      if (loadingEl) {
        loadingEl.textContent = 'Nie udało się załadować opinii. Spróbuj odświeżyć stronę.';
      }
    });
  }

  function fetchProductReviewsViaApi(root) {
    var productId = root.getAttribute('data-product-id');
    if (!hasApiConfig(root) || !productId) {
      return Promise.resolve(null);
    }

    return fetchWidget(root, 'product_review', { product_id: productId }).then(function (data) {
      var html = getWidgetField(data, 'product_review') || data.widget || '';
      var reviews = parseReviewsFromWidgetHtml(html);
      var summary = parseSummaryFromWidgetHtml(html);
      return { reviews: reviews, summary: summary };
    }).catch(function () {
      return null;
    });
  }

  function initRoot(root) {
    if (root.getAttribute('data-judgeme-initialized') === 'true') return;
    root.setAttribute('data-judgeme-initialized', 'true');

    // 2026-10-15 (Karol): zawsze 10 losowych opinii o sklepie, także na produktach z własnymi opiniami.
    // Tryb produktu poniżej zostaje na wypadek powrotu (wystarczy usunąć te dwie linie)
    fetchShopReviews(root);
    return;

    // Fill stars for SSR summary immediately
    var metaAvg = parseFloat(root.getAttribute('data-rating-average')) || 0;
    var metaCount = parseInt(root.getAttribute('data-review-count'), 10) || 0;
    if (metaAvg > 0) {
      updateSummary(root, { average: metaAvg, total: metaCount });
    }

    var productSource = parseProductSource(root);

    if (metaCount > 0 || productSource.reviews.length > 0) {
      if (productSource.reviews.length > 0) {
        finishWithReviews(root, productSource.reviews, productSource.summary || { average: metaAvg, total: metaCount });
        return;
      }

      // Widget markup may load asynchronously — try API, then wait for DOM
      fetchProductReviewsViaApi(root).then(function (apiResult) {
        if (apiResult && apiResult.reviews.length) {
          finishWithReviews(root, apiResult.reviews, apiResult.summary || { average: metaAvg, total: metaCount });
          return;
        }

        wakeJudgeMeWidgets();
        return wait(600).then(function () {
          var retry = parseProductSource(root);
          if (retry.reviews.length) {
            finishWithReviews(root, retry.reviews, retry.summary || { average: metaAvg, total: metaCount });
          } else {
            return fetchShopReviews(root);
          }
        });
      });
      return;
    }

    fetchShopReviews(root);
  }

  function init(scope) {
    getRoots(scope).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
